import { render, staticRenderFns } from "./EditIssueTracker.vue?vue&type=template&id=70f9d172&lang=pug"
import script from "./EditIssueTracker.vue?vue&type=script&lang=js"
export * from "./EditIssueTracker.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports